export default {
  'contact.title': 'Get In Touch',
  'contact.subtitle': 'Ready to transform your business with our technology solutions? Contact us today to discuss your needs and discover how we can help you achieve your goals.',
  
  'contact.info.title': 'Contact Information',
  'contact.info.description': 'We\'re here to help and answer any question you might have. We look forward to hearing from you.',
  
  'contact.form.name': 'Full Name',
  'contact.form.email': 'Email Address',
  'contact.form.phone': 'Phone Number',
  'contact.form.company': 'Company',
  'contact.form.subject': 'Subject',
  'contact.form.message': 'Message',
  'contact.form.send': 'Send Message',
  'contact.form.sending': 'Sending...',
  
  'contact.form.nameLabel': 'Full Name',
  'contact.form.emailLabel': 'Email Address',
  'contact.form.phoneLabel': 'Phone Number',
  'contact.form.companyLabel': 'Company',
  'contact.form.serviceLabel': 'Service Interest',
  'contact.form.messageLabel': 'Message',
  'contact.form.selectService': 'Select a service',
  'contact.form.messagePlaceholder': 'Tell us about your project or investment interest...',
  
  'contact.form.services.digitalPayments': 'Digital Payment Solutions',
  'contact.form.services.bankingSoftware': 'Banking Software',
  'contact.form.services.customDevelopment': 'Custom Software Development',
  'contact.form.services.investment': 'Strategic Tech Investment',
  'contact.form.services.cyclosSupport': 'Cyclos Support',
  'contact.form.services.consultation': 'General Consultation',
  'contact.success': 'Thank you! Your message has been sent successfully.',
  'contact.error': 'Sorry, there was an error sending your message. Please try again.',
  
  'contact.address.title': 'Office Address',
  'contact.phone.title': 'Phone Number',
  'contact.email.title': 'Email Address',
  
  'contact.businessHours.title': 'Business Hours',
  'contact.businessHours.weekdays': 'Monday - Friday',
  'contact.businessHours.weekdaysHours': '9:00 AM - 6:00 PM',
  'contact.businessHours.saturday': 'Saturday',
  'contact.businessHours.saturdayHours': '10:00 AM - 4:00 PM',
  'contact.businessHours.sunday': 'Sunday',
  'contact.businessHours.closed': 'Closed',
};
